

// export const fullTourSteps = [

//     /* ---------------- INSTRUCTIONS ---------------- */
//     {
//         route: "/dummy-instructions",
//         selector: "#confirm-read",
//         title: "Read and Confirm Instructions",
//         text: "Carefully read all exam rules, guidelines, and restrictions. You must confirm that you understand them by selecting the checkbox before proceeding.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-instructions",
//         selector: ".buttons-container .btn",
//         title: "Proceed to Exam",
//         text: "Once you are ready and have read all instructions, click here to enter the exam environment. The timer will begin after this.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-instructions",
//         selector: ".confirm-btn.start",
//         title: "Start the Exam",
//         text: "Final step! Click **Start Exam** to begin your assessment. Good luck!",
//         allowInteraction: true,
//     },

//     /* ---------------- EXAM PAGE ---------------- */

//     {
//         route: "/examportal-mock",
//         selector: ".InterviewHeader.CourseBox",
//         title: "Exam Header & Timer",
//         text: "This section displays the exam name, and the remaining time. Keep an eye on the timer to manage your pace effectively.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".question-card",
//         title: "Question Panel",
//         text: "This area shows the current question. Read the question carefully before selecting or changing your answer.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".options-container",
//         title: "Answer Options",
//         text: "Choose the correct option(s) for the question. Your selection is automatically saved when you click on Save & Next button.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".question-actions",
//         title: "Question Controls",
//         text: "Use these buttons to move to the next or previous question, clear your answer, or mark a question for later review.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".question-navigator",
//         title: "Question Navigator",
//         text: "This panel allows you to jump directly to any question. Different colors indicate answered, unanswered, and marked-for-review questions.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".progress-overview",
//         title: "Progress Overview",
//         text: "This section provides a summary of your progress, including how many questions are answered, unanswered, or marked for review.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".submit-exam-btn",
//         title: "Submit Exam",
//         text: "When you have completed the exam or wish to end it early, click here. You will be asked to confirm your Submission before final submission.",
//         action: "OPEN_SUBMIT_DIALOG",
//     },

//     /* ---------------- SUBMIT SUMMARY ---------------- */

//     {
//         route: "/dummy-exampage",
//         selector: ".submit-summary",
//         title: "Submission Summary",
//         text: "Review a complete summary of your exam attempt, including answered, unanswered, and marked questions, before making the final decision.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".submit-cancel-btn",
//         title: "Return to Exam",
//         text: "If you wish to modify your answers, click here to return to the exam and continue attempting questions.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".final-submit-btn",
//         title: "Final Exam Submission",
//         text: "Click this button to permanently submit your exam. After submission, you will not be able to make any further changes.",
//     },
// ];

// export const fullTourSteps = [
//     /* ---------------- INSTRUCTIONS ---------------- */
//     {
//         route: "/dummy-instructions",
//         selector: "#confirm-read",
//         title: "Read and Confirm Instructions",
//         text: "Carefully read all exam rules, guidelines, and restrictions. You must confirm that you understand them by selecting the checkbox before proceeding.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-instructions",
//         selector: ".buttons-container .btn",
//         title: "Proceed to Exam",
//         text: "Once you are ready and have read all instructions, click here to enter the exam environment. The timer will begin after this.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-instructions",
//         selector: ".confirm-btn.start",
//         title: "Start the Exam",
//         text: "Final step! Click **Start Exam** to begin your assessment. Good luck!",
//         allowInteraction: true,
//     },

//     /* ---------------- EXAM PAGE ---------------- */
//     {
//         route: "/examportal-mock",
//         selector: ".InterviewHeader.CourseBox",
//         title: "Exam Header & Timer",
//         text: "This section displays the exam name and the remaining time. Keep an eye on the timer to manage your pace effectively.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".question-card",
//         title: "Question Panel",
//         text: "This area shows the current question. Read the question carefully before selecting or changing your answer.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".options-container",
//         title: "Answer Options",
//         text: "Choose the correct option(s) for the question. Your selection is automatically saved.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".question-actions",
//         title: "Question Controls",
//         text: "Use these buttons to move to the next or previous question, clear your answer, or mark a question for later review.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".question-navigator",
//         title: "Question Navigator",
//         text: "This panel allows you to jump directly to any question. Different colors indicate answered, unanswered, and marked-for-review questions.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".progress-overview",
//         title: "Progress Overview",
//         text: "This section provides a summary of your progress, including how many questions are answered, unanswered, or marked for review.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".submit-exam-btn",
//         title: "Submit Exam",
//         text: "When you have completed the exam or wish to end it early, click here. You will be asked to confirm your Submission before final submission.",
//         allowInteraction: true,
//     },

//     /* ---------------- SUBMIT SUMMARY ---------------- */
//     {
//         route: "/examportal-mock",
//         selector: ".submit-summary",
//         title: "Submission Summary",
//         text: "Review a complete summary of your exam attempt, including answered, unanswered, and marked questions, before making the final decision.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".submit-cancel-btn",
//         title: "Return to Exam",
//         text: "If you wish to modify your answers, click here to return to the exam and continue attempting questions.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".final-submit-btn",
//         title: "Final Exam Submission",
//         text: "Click this button to permanently submit your exam. After submission, you will not be able to make any further changes.",
//         allowInteraction: true,
//     },
// ];



// export const fullTourSteps = [
//     /* ---------------- INSTRUCTIONS ---------------- */
//     {
//         route: "/dummy-instructions",
//         selector: "#confirm-read",
//         title: "Read and Confirm Instructions",
//         text: "Carefully read all exam rules, guidelines, and restrictions. You must confirm that you understand them by selecting the checkbox before proceeding.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-instructions",
//         selector: ".buttons-container .btn",
//         title: "Proceed to Exam",
//         text: "Once you are ready and have read all instructions, click here to enter the exam environment. The timer will begin after this.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-instructions",
//         selector: ".confirm-btn.start",
//         title: "Start the Exam",
//         text: "Final step! Click **Start Exam** to begin your assessment. Good luck!",
//         allowInteraction: true,
//     },

//     /* ---------------- EXAM PAGE ---------------- */
//     {
//         route: "/examportal-mock",
//         selector: ".InterviewHeader.CourseBox",
//         title: "Exam Header & Timer",
//         text: "This section displays the exam name and the remaining time. Keep an eye on the timer to manage your pace effectively.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: 'div[style*="position: fixed"][style*="top: 10"][style*="right: 10"] button',  // targets the red violation button
//         title: "Violation Simulation (Testing Only)",
//         text: "It simulates a proctoring violation (e.g. looking away, tab switch).\nAfter 3 violations, the exam will auto-submit.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".question-card",
//         title: "Question Panel",
//         text: "This area shows the current question. Read the question carefully before selecting or changing your answer.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".options-container",
//         title: "Answer Options",
//         text: "Choose the correct option(s) for the question. Your selection is automatically saved.",
//         allowInteraction: true,
//     },

//     // ──── IMPROVED: Focus on the most used button ────
//     {
//         route: "/examportal-mock",
//         selector: ".question-actions .BlueBtn",          // Targets only "Save & Next"
//         title: "Save & Next",
//         text: "Click here to **save your current answer** and move to the next question.\nThis is the button you'll use most often during the exam.",
//         allowInteraction: true,
//     },

//     // Optional: Show other controls (non-interactive - safer)
//     {
//         route: "/examportal-mock",
//         selector: ".question-actions",
//         title: "Other Question Controls",
//         text: "Use these additional buttons when needed:\n• ← Back\n• 📌 Mark for Review & Next\n• 🗑️ Clear Response\n• ➡ Save & Next",
//         allowInteraction: true,   // User clicks "Next" manually → no skipping issue
//     },

//     {
//         route: "/examportal-mock",
//         selector: ".question-navigator",
//         title: "Question Navigator",
//         text: "This panel allows you to jump directly to any question. Different colors indicate answered, unanswered, and marked-for-review questions.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".progress-overview",
//         title: "Progress Overview",
//         text: "This section provides a summary of your progress, including how many questions are answered, unanswered, or marked for review.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".submit-exam-btn",
//         title: "Submit Exam",
//         text: "When you have completed the exam or wish to end it early, click here. You will be asked to confirm your Submission before final submission.",
//         allowInteraction: true,
//     },

//     /* ---------------- SUBMIT SUMMARY ---------------- */
//     /* ---------------- SUBMIT SUMMARY ---------------- */
//     {
//         route: "/examportal-mock",
//         selector: ".submit-summary",
//         title: "Submission Summary",
//         text: "Review your exam summary here:\n• Answered questions\n• Not answered\n• Marked for review\nMake sure everything looks correct before final submission.",
//         allowInteraction: false,   // No auto-advance – user should read carefully
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".submit-cancel-btn",
//         title: "Return to Exam",
//         text: "Not ready yet? Click here to **go back** to the exam and continue answering or reviewing questions.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".final-submit-btn",
//         title: "Final Submission",
//         text: "When you're completely ready, click **Submit Final** to permanently submit your exam.\n\n**Warning:** After this step, you cannot make any changes!",
//         allowInteraction: true,
//     },
// ];


// export const fullTourSteps = [
//     /* ──────────────────────────────────────────────
//        INSTRUCTIONS PAGE
//     ────────────────────────────────────────────── */
//     {
//         route: "/dummy-instructions",
//         selector: "#confirm-read",
//         title: "Read and Confirm Instructions",
//         text: "Carefully read all exam rules, guidelines, and restrictions. You must confirm that you understand them by selecting the checkbox before proceeding.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-instructions",
//         selector: ".buttons-container .btn",
//         title: "Proceed to Exam",
//         text: "Once you are ready and have read all instructions, click here to enter the exam environment. The timer will begin after this.",
//         allowInteraction: true,
//     },
//     {
//         route: "/dummy-instructions",
//         selector: ".confirm-btn.start",
//         title: "Start the Exam",
//         text: "Final step! Click **Start Exam** to begin your assessment. Good luck!",
//         allowInteraction: true,
//     },

//     /* ──────────────────────────────────────────────
//        EXAM MAIN INTERFACE
//     ────────────────────────────────────────────── */
//     {
//         route: "/examportal-mock",
//         selector: ".InterviewHeader.CourseBox",
//         title: "Exam Header & Timer",
//         text: "This section shows the exam title and remaining time. Keep an eye on the timer to manage your pace.",
//         allowInteraction: true,
//     },

//     // {
//     //     route: "/examportal-mock",
//     //     selector: ".violation-btn",
//     //     title: "Violation Simulation (Dev Tool)",
//     //     text: "Testing button only.\nSimulates proctoring violations.\nAfter 3 violations → auto-submit.\nNot visible to real candidates.",
//     //     allowInteraction: true,
//     // },

//     {
//         route: "/examportal-mock",
//         selector: ".question-card",
//         title: "Question Area",
//         text: "Current question is displayed here. Read carefully before answering.",
//         allowInteraction: true,
//     },
//     {
//         route: "/examportal-mock",
//         selector: ".options-container",
//         title: "Answer Options",
//         text: "Select correct option(s). Answers are auto-saved.",
//         allowInteraction: true,
//     },


    // {
    //     route: "/examportal-mock",
    //     selector: ".question-actions",
    //     title: "Other Question Controls",
    //     text: "Additional actions:\n← Back\n📌 Mark for Review & Next\n🗑️ Clear Response\n ➡ Save & Next",
    //     allowInteraction: true,
    // },

//     {
//         route: "/examportal-mock",
//         selector: ".question-navigator",
//         title: "Question Navigator",
//         text: "Jump to any question.\nColors show status:\n• Answered\n• Not answered\n• Marked for review",
//         allowInteraction: true,     // ← Show whole panel clearly
//     },

//     // {
//     //     route: "/examportal-mock",
//     //     selector: ".progress-overview",
//     //     title: "Progress Overview",
//     //     text: "Summary of your overall exam progress.",
//     //     allowInteraction: true,
//     // },

//     {
//         route: "/examportal-mock",
//         selector: ".submit-exam-btn",
//         title: "Submit Exam",
//         text: "Click here when ready to finish.\nConfirmation dialog will appear for final review.",
//         allowInteraction: true,      // User can click it → dialog opens
//     },

//     /* ──────────────────────────────────────────────
//        SUBMISSION CONFIRMATION DIALOG FLOW
//     ────────────────────────────────────────────── */
//   /* ---------------- SUBMISSION CONFIRMATION ---------------- */

// {
//     route: "/examportal-mock",
//     selector: ".submit-summary",
//     title: "Submission Summary",
//     text: "Quick review before final decision:\n• Answered questions\n• Not answered\n• Marked for review",
//     allowInteraction: true,
// },

// {
//     route: "/examportal-mock",
//     selector: ".submit-cancel-btn",
//     title: "Return to Exam",
//     text: "If you wish to modify your answers, click here to return to the exam and continue attempting questions.",
//     allowInteraction: true,
// },

// {
//     route: "/examportal-mock",
//     selector: ".final-submit-btn",
//     title: "Final Exam Submission",
//     text: "Click this button to permanently submit your exam. After submission, you will not be able to make any further changes.",
//     allowInteraction: true,
// },
// ];



export const fullTourSteps = [
    /* ──────────────────────────────────────────────
       INSTRUCTIONS PAGE
    ────────────────────────────────────────────── */
    {
        route: "/dummy-instructions",
        selector: "#confirm-read",
        title: "Read and Confirm Instructions",
        text: "Carefully read all exam rules, guidelines, and restrictions. You must confirm that you understand them by selecting the checkbox before proceeding.",
        allowInteraction: true,
    },
    {
        route: "/dummy-instructions",
        selector: ".buttons-container .btn",
        title: "Proceed to Exam",
        text: "Once you are ready and have read all instructions, click here to enter the exam environment. The timer will begin after this.",
        allowInteraction: true,
    },
    {
        route: "/dummy-instructions",
        selector: ".confirm-btn.start",
        title: "Start the Exam",
        text: "Click **Start Exam** to begin your assessment. Good luck!",
        allowInteraction: true,
    },

    /* ──────────────────────────────────────────────
       EXAM MAIN INTERFACE
    ────────────────────────────────────────────── */
    {
        route: "/examportal-mock",
        selector: ".InterviewHeader.CourseBox",
        title: "Exam Header & Timer",
        text: "This section shows the exam title and remaining time. Keep an eye on the timer to manage your pace.",
        allowInteraction: true,
    },

    {
        route: "/examportal-mock",
        selector: ".question-box",
        title: "Question Area",
        text: "Current question is displayed here. Read carefully before answering.",
        allowInteraction: true,
    },
    {
        route: "/examportal-mock",
        selector: ".options",
        title: "Answer Options",
        text: "Select correct option(s). Answers are auto-saved.",
        allowInteraction: true,
    },

    {
        route: "/examportal-mock",
        selector: ".actions",
        title: "Other Question Controls",
        text: "Additional actions:\n← Back\n📌 Mark for Review & Next\n🗑️ Clear Response\n ➡ Save & Next",
        allowInteraction: true,
    },

    {
        route: "/examportal-mock",
        selector: ".navigator",
        title: "Question Navigator",
        text: "Jump to any question.",
        allowInteraction: true,
    },

     {
        route: "/examportal-mock",
        selector: ".progress-list",
        title: "Progress Overview",
        text: "Colors show status:\n• Answered (Green Colour) \n• Not answered (Grey colour) \n• Marked for review (Yellow colour)",
        allowInteraction: true,
    },
    

    {
        route: "/examportal-mock",
        selector: ".mock",
        title: "Submit Exam",
        text: "Click here when ready to finish.\nConfirmation dialog will appear for final review.",
        allowInteraction: true,
    },

    /* ──────────────────────────────────────────────
       SUBMISSION DIALOG BUTTONS (ON SAME ROUTE)
    ────────────────────────────────────────────── */
    // {
    //     route: "/examportal-mock",
    //     selector: ".submit-cancel-btn",
    //     title: "Return to Exam",
    //     text: "If you wish to modify your answers, click here to return to the exam and continue attempting questions.",
    //     allowInteraction: true,
    // },

    {
        route: "/examportal-mock",
        selector: ".mock1",
        title: "Final Exam Submission",
        text: "Click this button to permanently submit your exam. After submission, you will not be able to make any further changes.",
        allowInteraction: true,
        // Optional: Add a condition to only show when dialog is open
        // condition: () => document.querySelector('.MuiDialog-root')?.style.display !== 'none'
    },

    /* ──────────────────────────────────────────────
       SUCCESS MODAL BUTTONS
    ────────────────────────────────────────────── */
    // {
    //     route: "/examportal-mock",
    //     selector: ".success-close-btn",
    //     title: "Close Results",
    //     text: "Click here to return to your dashboard.",
    //     allowInteraction: true,
    // },

    {
        route: "/examportal-mock",
        selector: ".success-view-btn",
        title: "View Results",
        text: "Final Step!, Click here to see detailed exam results and review your answers.Click End Tour button to end this Guided tour.",
        allowInteraction: true,
    },
];